module.exports = __webpack_public_path__ + "b555b6e3ec3ef07856c21dd67db0919d.jpg";